var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLifestyle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2269_7769)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.37794 11.2217C9.37794 11.9827 8.76104 12.5996 8.00001 12.5996C7.23898 12.5996 6.62207 11.9827 6.62207 11.2217C6.62207 10.4607 7.23901 9.84375 8.00001 9.84375C8.76101 9.84375 9.37794 10.4607 9.37794 11.2217Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1992 15.5313V14.7988C10.1992 13.5842 9.21459 12.5996 8 12.5996C6.78541 12.5996 5.80078 13.5842 5.80078 14.7988V15.5313H10.1992Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8.66284H1.875",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.800293 6.45654H4.08154",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.875 10.5378V8.66284",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.08154 9.73779V6.45654",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.875 8.66297L5.07581 5.46216",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0058 0.838039C9.51345 0.345695 8.71523 0.345695 8.22291 0.838039L8.00004 1.06088L7.77716 0.838008C7.28482 0.345664 6.4866 0.345664 5.99426 0.838008C5.50191 1.33035 5.50191 2.12857 5.99426 2.62088L8.00004 4.62666L10.0058 2.62091C10.4981 2.1286 10.4981 1.33035 10.0058 0.838039Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7812 10.8125H15.5312V5.1875L11.7812 5.1875V10.8125Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.125 7.0625H13.1875",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2188 1.40625H13.1875C13.9642 1.40625 14.5938 2.03584 14.5938 2.8125V3.78125",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.78125 14.5938H2.8125C2.03584 14.5938 1.40625 13.9642 1.40625 13.1875V12.2188",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.78125 1.40625H2.8125C2.03584 1.40625 1.40625 2.03584 1.40625 2.8125V3.78125",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2188 14.5938H13.1875C13.9642 14.5938 14.5938 13.9642 14.5938 13.1875V12.2188",
    stroke: "white",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2269_7769"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifestyle);
export default __webpack_public_path__ + "static/media/lifestyle.d0e8baf61d22e1455546cbb825bd1f15.svg";
export { ForwardRef as ReactComponent };